import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { apiTaxesv2 } from '../services/Api';
import { showToast } from '../utils';
import { useParams } from "react-router-dom";

interface Rate {
  installment: number;
  value: string;
  rateLimitValue: string | null;
  paymentFeeType: string;
  brandCard: string;
}

interface history {
  content: any[];
  size: number;
  numberOfElements: number;
  totalElements: number;

}

interface TaxesContextData {
  brands: Rate[];
  sellerRates: Rate[];
  history: history;
  signedUrl: string | null;
  loading: boolean;
  fetchRateBrands: () => Promise<void>;
  fetchRateSeller: () => Promise<void>;
  fetchHistorySeller: (page: number, limit: number) => Promise<void>;
  fetchSignedUrl: (id: number) => Promise<void>;
}

const TaxesContext = createContext<TaxesContextData | undefined>(undefined);

export const TaxesProvider = ({ children }: { children: ReactNode }) => {
  const [brands, setBrands] = useState<Rate[]>([]);
  const [sellerRates, setSellerRates] = useState<Rate[]>([]);
  const [history, setHistory] = useState<history>();
  const [signedUrl, setSignedUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  let { id } = useParams();

  const fetchRateBrands = async () => {
    try {
      setLoading(true);
      const response = await apiTaxesv2.get('service/tax/brands');
      setBrands(response.data);
    } catch (error) {
      console.error('Erro ao buscar taxas de marcas:', error);
      showToast({ type: 'error', message: 'Falha ao carregar taxas de marcas' });
    } finally {
      setLoading(false);
    }
  };

  const fetchRateSeller = async (idseller?: number) => {
    try {
      setLoading(true);
      const response = await apiTaxesv2.get(`service/tax/seller?idSeller=${id}`);
      setSellerRates(response.data);
      return response.data
    } catch (error) {
      console.error('Erro ao buscar taxas do vendedor:', error);
      showToast({ type: 'error', message: 'Falha ao carregar taxas do vendedor' });
    } finally {
      setLoading(false);
    }
  };

  const fetchHistorySeller = async (pageNumber: number, limitNumber: number) => {

    try {
      setLoading(true);
      const response = await apiTaxesv2.get(`service/tax/history/seller?idSeller=${id}&size=${limitNumber}`);
      if (response) {
        setHistory(response?.data)
      }
    } catch (error) {
      console.error("Erro ao buscar histórico do vendedor:", error);
      // showToast({ type: "error", message: "Falha ao carregar histórico" });
    } finally {
      setLoading(false);
    }
  };

  const fetchSignedUrl = async () => {
    try {
      setLoading(true);
      const response = await apiTaxesv2.get(`service/tax/history/${id}/signed-url`);
      setSignedUrl(response.data);
    } catch (error) {
      console.error('Erro ao buscar URL assinada:', error);
      showToast({ type: 'error', message: 'Falha ao carregar URL assinada' });
    } finally {
      setLoading(false);
    }
  };



  useEffect(() => {
    // fetchRateSeller();
    // fetchRateBrands();
  }, [])

  return (
    <TaxesContext.Provider
      value={{
        brands,
        sellerRates,
        history,
        signedUrl,
        loading,
        fetchRateBrands,
        fetchRateSeller,
        fetchHistorySeller,
        fetchSignedUrl,

      }}
    >
      {children}
    </TaxesContext.Provider>
  );
};

export const useTaxes = () => {
  const context = useContext(TaxesContext);
  if (!context) {
    throw new Error('useTaxes deve ser usado dentro de um TaxesProvider');
  }
  return context;
};
